<template lang="html">


  <section class="footer">

    <newsletter></newsletter>

    <div class="real-footer row-between">

      <a href="http://www.carretilla.info/" target="_blank" class="volver">
        <img src="/static/img/logo-texto-blanco.svg" alt="Volver a carretilla">
      </a>

      <nav class="row-center">
        <a class="legal" target="blank" href="https://www.carretilla.info/aviso-legal">Aviso legal y política de privacidad</a>
        <a class="legal" target="blank" href="https://www.carretilla.info/cookies">Política de Cookies</a>
        <!-- <idioma></idioma> -->
      </nav>

      <nav class="rrss">
        <a target="_blank" href="https://www.instagram.com/carretilla_oficial/"><i class="fa fa-instagram"></i></a>
        <a target="_blank" href="https://www.facebook.com/carretillacomoesnatural"><i class="fa fa-facebook-square"></i></a>
        <a target="_blank" href="https://twitter.com/ElCarretillero"><i class="fa-brands fa-x-twitter"></i></a>
        <a target="_blank" href="https://www.youtube.com/user/carretilla"><i class="fa fa-youtube"></i></a>
      </nav>



    </div>


  </section>

</template>

<script lang="js">

  import idioma from '@/components/view-parts/footer/idioma'

  import newsletter from '@/components/parts/newsletter';

  export default  {
    name: 'app-footer',
    props: [],
    mounted() {

    },
    data() {
      return {

      }
    },
    methods: {

    },
    components: {
      'idioma' : idioma,
      'newsletter' : newsletter
    }
  }
</script>

<style scoped>
.real-footer {
  background: #212c55;
  padding: 20px 20px;
}

.volver{
  padding-left: 30px;
  position: relative;
}

.volver img{
  display: block;
}

.volver::before{
  border: 6px solid transparent;
  content: '';
  display: inline-block;
  border-right-color: white;
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
}

.rrss a{
  padding: 10px;
  font-size: 24px;
  color: #ffffff; 
}

.legal{
  padding-right: 20px;
  color: #fff;
  font-family: 'philosopherregular';
}

/*.legal::after{
  margin-left: 20px;
  content: '-';
}
*/
@media screen and (max-width: 840px){
  .real-footer{
    -webkit-flex-direction: column;
    -moz-flex-direction: column;
    -ms-flex-direction: column;
    -o-flex-direction: column;
    flex-direction: column;
  }

  .volver{
    margin-bottom: 20px;
  }
  
  .rrss{
    margin-top: 10px;
  }

}


@media screen and (max-width: 600px){
  .legal{
    padding-right: 0;
    margin-bottom: 10px;
  }

  .legal::after{
    display: none;
  }
  .rrss a i{
    width: 40px;
    }
}

</style>



// WEBPACK FOOTER //
// src/components/parts/footer.vue